<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<ng-container *ngIf="products$ | async as products">
  <div
    *ngIf="products.length > 0"
    lazyLoad
    (lazyLoad)="onFirstView()">
    <idt-common-styles-render
      *ngIf="piece"
      [styles]="piece.settings?.styles">

      <header
        *ngIf="piece && showSliderHeader"
        class="slider-title">

        <render-wysiwyg
          *ngIf="piece.settings?.general?.showTitle
            && piece.settings?.general?.textGridTitle !== null"
          [piece]="piece"
          [html]="piece.settings?.general?.textGridTitle"
          [textPaddingTop]="piece.settings?.general?.textTitlePadding?.textPaddingTop"
          [textPaddingBottom]="piece.settings?.general?.textTitlePadding?.textPaddingBottom"
          [textPaddingLeft]="piece.settings?.general?.textTitlePadding?.textPaddingLeft"
          [textPaddingRight]="piece.settings?.general?.textTitlePadding?.textPaddingRight">
        </render-wysiwyg>

        <ng-container
          *ngIf="arrowPosition === 'header-right';
          then sliderArrows">
        </ng-container>

      </header>
      <div
        class="carousel-wrapper">
          <swiper
            *ngIf="products"
            [config]="swiperConfig">
            <ng-template
              *ngFor="let product of products; let index = index; trackBy: trackByProduct"
              swiperSlide>
              <div
                class="product-card">
                <render-link
                  class="image-link-product"
                  [lang]="lang"
                  [link]="getProductLink(product, index)"
                  (renderLinkEvent)="onProductLinkClick(product, index)">
                    <img
                      *ngIf="getProductImageData(product); let imageData"
                      [class]="imageClass"
                      [lazySrc]="imageData"
                      alt="{{ product.name }}"/>
                </render-link>

                <div
                  *ngIf="isVisibleName() || isVisiblePrice()  || isVisibleCartDeprecated() || isVisibleButtonLink()"
                  class="product-data">
                  <render-wysiwyg
                    *ngIf="isVisibleName()"
                    class="product-name"
                    [html]="getTextProductName(product.name)"
                    [piece]="piece">
                  </render-wysiwyg>
                  <render-product-prices
                    *ngIf="isVisiblePrice()"
                    [product]="product"
                    [piece]="piece">
                  </render-product-prices>
                  <button
                    *ngIf="isVisibleCartDeprecated()"
                    class="product-button">
                    <div
                      *ngIf="piece.settings?.general?.displayProductTextAddToCart && piece.settings?.general?.productAddToCartTextFormat"
                      class="wysiwyg">
                      <render-wysiwyg
                        [html]="piece.settings?.general?.productAddToCartTextFormat"
                        [piece]="piece"
                        [textPaddingTop]="piece.settings?.general?.textPaddingTop"
                        [textPaddingBottom]="piece.settings?.general?.textPaddingBottom"
                        [textPaddingLeft]="piece.settings?.general?.textPaddingLeft"
                        [textPaddingRight]="piece.settings?.general?.textPaddingRight">
                      </render-wysiwyg>
                    </div>
                    <svg
                      *ngIf="piece.settings?.general?.displayProductIconAddToCart"
                      viewBox="0 0 16 16">
                      <path d="M0 .76V2.4h1.06l3.78 9.07a.8.8 0 0 0 .76.53h7.18c.38 0 .64-.22.75-.53l2.42-6.42a.8.8 0 0 0-.75-1.06H3.48L2.34 1.29A.8.8 0 0 0 1.6.76zM4.16 5.6h9.9l-1.81 4.8H6.12zm2.65 7.98a1.21 1.21 0 1 0 0 2.42 1.21 1.21 0 0 0 0-2.42zm4.76 0a1.21 1.21 0 1 0 0 2.42 1.21 1.21 0 0 0 0-2.42z"/>
                    </svg>
                  </button>
                  <render-link
                    *ngIf="isVisibleButtonLink()"
                    class="button-link-product"
                    [lang]="lang"
                    [link]="getProductLink(product, index)">
                    <render-wysiwyg
                      [html]="piece.settings?.general?.textButtonLink"
                      [piece]="piece"
                      [textPaddingTop]="piece.settings?.general?.textPaddingTop"
                      [textPaddingBottom]="piece.settings?.general?.textPaddingBottom"
                      [textPaddingLeft]="piece.settings?.general?.textPaddingLeft"
                      [textPaddingRight]="piece.settings?.general?.textPaddingRight">
                    </render-wysiwyg>
                  </render-link>
                </div>
                <render-product-purchase-options
                  *ngIf="isVisibleCart()"
                  class="product-sizes"
                  [product]="product"
                  [country]="country"
                  [lang]="lang"
                  [piece]="piece">
                </render-product-purchase-options>
              </div>
            </ng-template>
        </swiper>

        <ng-container
          *ngIf="arrowPosition === 'inside-left-right';
          then sliderArrows">
        </ng-container>
      </div>
    </idt-common-styles-render>
  </div>

  <ng-template #sliderArrows>
    <div
      *ngIf="displayComponentArrows && isScrollPager"
      class="component-arrows arrow-control">
      <button
        (click)="arrowClick('prev')"
        class="arrow-left"
        [disabled]="isFirstSlide">
        <svg
          class="swiper-arrow"
          viewBox="0 0 11 16"
          fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z" />
        </svg>
      </button>
      <button
        (click)="arrowClick('next')"
        class="arrow-right"
        [disabled]="isLastSlide">
        <svg
          class="swiper-arrow"
          viewBox="0 0 11 16"
          fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
        </svg>
      </button>
    </div>
  </ng-template>
</ng-container>
